module.exports = __webpack_public_path__ + "static/media/avatar.cd4345d9.png";